import { render } from "./BoletoAnuidade.vue?vue&type=template&id=02ec5e20&scoped=true"
import script from "./BoletoAnuidade.vue?vue&type=script&lang=js"
export * from "./BoletoAnuidade.vue?vue&type=script&lang=js"

import "./BoletoAnuidade.vue?vue&type=style&index=0&id=02ec5e20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02ec5e20"]])

export default __exports__